<form #kvForm="ngForm" name="kvForm" class="form">
    <label for="inputFirstName" class="loginLabel">{{LOCALIZATION.firstName}}</label>
    <input type="text" [(ngModel)]='user.firstName' id="inputFirstName" name="inputFirstName" class="form-control" placeholder="{{LOCALIZATION.firstName}}" required autofocus>
	<span *ngIf="kvForm.form.controls['inputFirstName']?.invalid && kvForm.form.controls['inputFirstName']?.touched" class="required">
	  {{LOCALIZATION.required}}
	</span>    

    <label for="inputLastName" class="loginLabel">{{LOCALIZATION.lastName}}</label>
    <input type="text" [(ngModel)]='user.lastName' id="inputLastName" name="inputLastName" class="form-control" placeholder="{{LOCALIZATION.lastName}}" required>
	<span *ngIf="kvForm.form.controls['inputLastName']?.invalid && kvForm.form.controls['inputLastName']?.touched" class="required">
	  {{LOCALIZATION.required}}
	</span>    

    <label for="inputEmail" class="loginLabel">{{LOCALIZATION.email}}</label>
    <input type="text" [(ngModel)]='user.email' id="inputEmail" name="inputEmail" class="form-control" placeholder="{{LOCALIZATION.email}}" required>
	<span *ngIf="kvForm.form.controls['inputEmail']?.invalid && kvForm.form.controls['inputEmail']?.touched" class="required">
	  {{LOCALIZATION.required}}
	</span>    

    <label for="inputPhone" class="loginLabel">{{LOCALIZATION.phoneNumber}}</label>
    <input type="text" [(ngModel)]='user.phone' id="inputPhone" name="inputPhone" class="form-control" placeholder="{{LOCALIZATION.phoneNumber}}">
    
    <br>
    <button 
    	(click)="updateUser()" 
    	[disabled]="!kvForm.valid" 
    	type="submit" 
    	class="btn btn-primary pull-right" 
    	title="{{LOCALIZATION.update}}">
    		{{LOCALIZATION.update}}
    </button>
</form>
                    